export const CITY_COOKIE_NAME = 'selectedCity'
export const CITY_COOKIE_MAX_AGE = 60 * 60 * 24 * 365

export function setCityCookie(cityName: string): void {
  document.cookie = `${CITY_COOKIE_NAME}=${encodeURIComponent(
    cityName
  )}; max-age=${CITY_COOKIE_MAX_AGE}; path=/; samesite=lax`
}

export function getCityCookie(): string | null {
  const raw = document.cookie
    .split('; ')
    .find((item) => item.startsWith(`${CITY_COOKIE_NAME}=`))
    ?.slice(CITY_COOKIE_NAME.length + 1)

  if (!raw) return null

  try {
    return decodeURIComponent(raw)
  } catch {
    return null
  }
}
